import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UserAccount } from './user-account';
import { environment } from '../../../environments/environment';
import { AddUser } from './add-user';
import { EditUser } from './edit-user';
import { tap } from 'rxjs/operators/tap';
import { of } from 'rxjs/observable/of';
import { Area } from '../../core/constants/area';
import { SetCompanyContactModel } from './models/SetCompanyContactModel';
import { SetContactModel } from './models/SetContactModel';
import { AuthResponse } from '../models/auth-response.model';

@Injectable()
export class UserService {
  private usersSubject: BehaviorSubject<UserAccount[]> = new BehaviorSubject(null);
  public users$: Observable<UserAccount[]> = this.usersSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
  ) { }

  public getAll(): Observable<UserAccount[]> {
    const loadedUsers = this.usersSubject.getValue();
    if (loadedUsers) {
      return of(loadedUsers);
    }

    const url = `${environment.dotNetApiUrl}/${Area.core}/user`;
    return this.httpClient.get<UserAccount[]>(url)
      .pipe(
        tap((x: UserAccount[]) => this.usersSubject.next(x))
      );
  }
  public getAllReload(): Observable<UserAccount[]> {
    const url = `${environment.dotNetApiUrl}/${Area.core}/user`;
    return this.httpClient.get<UserAccount[]>(url)
      .pipe(
        tap((x: UserAccount[]) => this.usersSubject.next(x))
      );
  }

  public getById(userId: number): Observable<UserAccount> {
    const url = `${environment.dotNetApiUrl}/${Area.core}/user/${userId}`;
    return this.httpClient.get<UserAccount>(url);
  }

  public getUserLogin(userName: string, userPassword: string){
    const url = `${environment.dotNetApiUrl}/${Area.core}/user/login?userName=${userName}&userPassword=${userPassword}`;
    return this.httpClient.get<any[]>(url);
  }

  public getUserMfaLogin(userName: string, userPassword: string, mfaCode: string){
    const url = `${environment.dotNetApiUrl}/${Area.auth}/login`;

    const body = {userName, userPassword, mfaCode };
    return this.httpClient.post<AuthResponse>(url, body);
  }

  public getByEmail(email: string): Observable<UserAccount> {
    const url = `${environment.dotNetApiUrl}/${Area.core}/user/getByEmail?email=${email}`;
    return this.httpClient.get<UserAccount>(url);
  }

  public add(user: AddUser) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/user`;
    return this.httpClient.post<any[]>(url, user);
    /*return this.httpClient
      .post<UserAccount>(url, user)
      .pipe(
        tap((newUser: any) => {
          this.usersSubject.next([...this.usersSubject.getValue(), newUser])
        })
      );*/
  }

  public edit(user: EditUser) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/user`;
    return this.httpClient
      .put<UserAccount>(url, user)
      .pipe(
        tap((updatedUser: UserAccount) => {
          const currentUsers = this.usersSubject.getValue();
          if (currentUsers) {
            const filteredUsers = currentUsers.filter(x => x.id !== updatedUser.id);
            this.usersSubject.next([...filteredUsers, updatedUser]);
          }
        })
      );
  }

  public delete(userId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/user?userId=${userId}`;
    return this.httpClient.delete(url);
  }

  public getAllDivisionUsers(prefix: string){
    const url = `${environment.dotNetApiUrl}/${Area.core}/user/GetPrefixUsers?prefix=${prefix}`;
    return this.httpClient.get<UserAccount[]>(url)
    .pipe(
      tap((x: UserAccount[]) => this.usersSubject.next(x))
    );
  }

  public getRepDropdown() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/User/Rep/Dropdown`;

    return this.httpClient.get<any[]>(url);
  }

  public getCoreCompanyDropdown(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/Dropdown`;
    return this.httpClient.get<any[]>(url);
  }
  public getContactDropdown(companyId: number){
    const url = `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/Contact/Dropdown?companyId=${companyId}`;
    return this.httpClient.get<any[]>(url);
  }
  public setCompanyContact(model: SetCompanyContactModel) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/CompanyContact`;
    return this.httpClient.post<any[]>(url, model);
  }
  public setContact(model: SetContactModel) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/Contact`;
    return this.httpClient.post<any[]>(url, model);
  }


  //all in one add new phone number
  public setMfaPhoneNumber(userName: string, userPassword: string, phoneNumber: string, mfaCode: string){
    const phoneData = {userName: userName, userPassword: userPassword, phoneNumber: phoneNumber, mfaCode: mfaCode}
    const url = `${environment.dotNetApiUrl}/${Area.core}/user/SetMfaPhoneNumber`;
    return this.httpClient.post<any>(url, phoneData);
  }


}



// WEBPACK FOOTER //
// ./src/app/auth/users/user.service.ts